import React from "react"
import PropTypes from "prop-types"
import "../assets/css/theme.less"
import Footie from "./footie"
import Nav from "./nav"
import Seo from "./seo"

const Layout = ({ children, title, keywords, articleBody, description,metaImage,pathname,isAccessibleForFree,datePublished,dateModified}) => {
  return (
    <>
      <Seo 
        title = {title} 
        keywords = {keywords}
        description = {description}
        metaImage = {metaImage}
        pathname = {pathname}
        isAccessibleForFree = {isAccessibleForFree}
        datePublished = {datePublished}
        dateModified = {dateModified}
      />
      <Nav/>
      <main>{children}</main>
      <Footie/>
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout